import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { PAUSEQUEUE_TASK } from './actionTypes';
import { pauseQueueTaskSuccessful, pauseQueueTaskFailed } from './actions';

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

// Is user update successfull then direct plot user in redux.
function* pauseQueueTask({ payload: {task, token} }) {
    try {

        yield call(tasksAPI.pauseQueueTasks, task?.taskCode, token);
        // P01021-147: history.go() recargaba la página entera (perdiendo el filtro aplicado en
        // la tabla de tareas) — la página escucha loadingPauseQueueTask y refresca el listado.
        yield put(pauseQueueTaskSuccessful("ok"));
        
    } catch (error) {
        console.log(error)
        yield put(pauseQueueTaskFailed(error));
    }
}

export function* watchTaskUpdate() {
    yield takeEvery(PAUSEQUEUE_TASK, pauseQueueTask);
}

function* pauseQueueTaskSaga() {
    yield all([fork(watchTaskUpdate)]);
}

export default pauseQueueTaskSaga;